export const getStubToken = () => localStorage.getItem('utiqStub');

export const checkStubToken = () => {
  const utiqStub = new URLSearchParams(window.location.search).get('utiq_stub');
  if (utiqStub) {
    if (utiqStub === 'false') {
      localStorage.removeItem('utiqStub');
    } else {
      localStorage.setItem('utiqStub', utiqStub);
    }
  }
  if (utiqStub || getStubToken()) {
    localStorage.removeItem('utiqEligibility');
  }
};
